export default __webpack_public_path__ + "static/media/list-alt.ec225f8f.svg";